import _ from "lodash";
import countryJson from "../../jsons/countries.json";
import groupTypeJson from "../../jsons/groupType.json";
import stateJson from "../../jsons/states.json";
import indianStateJson from "../../jsons/indianState.json";
import indianCityJson from "../../jsons/indiaCities.json";
import slipType from "../../jsons/slipType.json";
import pType from "../../jsons/patientType.json";
import vType from "../../jsons/visitType.json";
import PaymentType from "../../jsons/paymentType.json";
import patientCategory from "../../jsons/patientCategory.json";
import referralCode from "../../jsons/referralCode.json";
import shipThrough from "../../jsons/shipThrough.json";
import expenseTypes from "../../jsons/expenseTypes.json";

export const Countries = [...countryJson];
export const States = [...stateJson];
export const IndianStates = [...indianStateJson];
export const shipthrough = [...shipThrough];
export const IndianCities = [...indianCityJson];
export const patientType = [...pType];
export const visitType = [...vType];
export const SlipType = [...slipType];
export const groupType = [...groupTypeJson];
export const PaymentTypes = [...PaymentType];
export const PatientCategory = [...patientCategory];
export const ReferralCode = [...referralCode];
export const ExpenseTypes = [...expenseTypes];
export const gstTypeList = [
    {name: "Unregistered Consumer", value: "Unregistered"},
    {name: "Registered Consumer", value: "Registered"},
];
export const gender = [
    {name: "Male", value: "male"},
    {name: "Female", value: "female"},
];

export const yesNo = [
    {name: "Yes", value: true},
    {name: "No", value: false},
];

export const testReport = [
    {
        "id": "1",
        "name": "Trichoscopy Test",

    },
    {
        "id": "2",
        "name": "Blood Test",

    },

];

export const diagnosis = [
    {
        "id": "1",
        "name": "Alopecia Androgenetica"
    },
    {
        "id": "2",
        "name": "Alopecia Areata"
    },
    {
        "id": "3",
        "name": "Alopecia Barbae"
    },
    {
        "id": "4",
        "name": "Alopecia Totalis"
    },
    {
        "id": "5",
        "name": "Alopecia Universalis"
    },
    {
        "id": "6",
        "name": "Bipolar Hair"
    },
    {
        "id": "7",
        "name": "Cicatricial Alopecia"
    },
    {
        "id": "8",
        "name": "Folliculitis"
    },
    {
        "id": "9",
        "name": "Hirsutism"
    },
    {
        "id": "10",
        "name": "Hypertrichosis"
    },
    {
        "id": "11",
        "name": "Miniaturization"
    },
    {
        "id": "12",
        "name": "Pediculosis"
    },
    {
        "id": "13",
        "name": "Pityriasis Capitis"
    },
    {
        "id": "14",
        "name": "Premature Graying"
    },
    {
        "id": "15",
        "name": "Seborrheic Dermatitis"
    },
    {
        "id": "16",
        "name": "Telogen Effluvium"
    },
    {
        "id": "17",
        "name": "Tinea Capitis"
    },
    {
        "id": "18",
        "name": "Traction Alopecia"
    },
    {
        "id": "19",
        "name": "Trichotillomania"
    }
];

export const complain = [
    {
        "id": "1",
        "name": "Allergic reactions to hair products"
    },
    {
        "id": "2",
        "name": "Baldness"
    },
    {
        "id": "3",
        "name": "Changes in hair texture"
    },
    {
        "id": "4",
        "name": "Dryness of the scalp"
    },
    {
        "id": "5",
        "name": "Excessive oiliness"
    },
    {
        "id": "6",
        "name": "Excessive sweating from the scalp"
    },
    {
        "id": "7",
        "name": "Frizzy hair"
    },
    {
        "id": "8",
        "name": "Hair breakage"
    },
    {
        "id": "9",
        "name": "Hair damage from chemical treatments"
    },
    {
        "id": "10",
        "name": "Hair damage from heat styling"
    },
    {
        "id": "11",
        "name": "Hair fall"
    },
    {
        "id": "12",
        "name": "Hair loss"
    },
    {
        "id": "13",
        "name": "Hair loss after childbirth"
    },
    {
        "id": "14",
        "name": "Hair matting"
    },
    {
        "id": "15",
        "name": "Hair pulling"
    },
    {
        "id": "16",
        "name": "Hair tangling"
    },
    {
        "id": "17",
        "name": "Hair thinning"
    },
    {
        "id": "18",
        "name": "Oily flaky dandruff"
    },
    {
        "id": "19",
        "name": "Patchy Hair Loss"
    },
    {
        "id": "20",
        "name": "Premature graying of hair"
    },
    {
        "id": "21",
        "name": "Receding hair line"
    },
    {
        "id": "22",
        "name": "Scalp infections"
    },
    {
        "id": "23",
        "name": "Scalp itchiness"
    },
    {
        "id": "24",
        "name": "Scalp pain"
    },
    {
        "id": "25",
        "name": "Scalp psoriasis"
    },
    {
        "id": "26",
        "name": "Scalp sunburn"
    },
    {
        "id": "27",
        "name": "Unwanted hair"
    }
];



export const branchType = [
    {
        name: "Head Branch",
        key: "headBranch",
    },
    {
        name: "Branch",
        key: "branch",
    },
];

export const UsersType = [
    {
        name: "Purchase User",
        key: "purchaseUser",
    },
    {
        name: "Transfer User",
        key: "transferUser",
    },
];
export const generateSaleProduct = [
    {
        name: "SaleProduct",
        _id: "1",
        price: "5000",
        hsnCode: "34",
    },
];

export const getStateByCountry = (countryName) => {
    let findCountry = _.find(countryJson, (item) => {
        return item.name === countryName;
    });
    if (findCountry) {
        let stateList = _.filter(stateJson, (item) => {
            return item.country_id === findCountry.id;
        });
        return stateList;
    } else {
        return [];
    }
};

export const getCityByState = (stateName) => {
    let findState = _.find(stateJson, (item) => {
        return item.name === stateName;
    });
    if (findState) {
        let cityList = _.filter(indianCityJson, (item) => {
            return item.state_id === findState.id;
        });
        return cityList;
    } else {
        return [];
    }
};
export const monthYearPicker = (data) => {
    // data = data.toString()
    data = data.replace("/", "").replace(/[^\d]/, "");
    let month = data.substring(0, 2);
    let year = data.substring(2, 6);
    let date = "";
    if (month) {
        date = date + month;
    }
    if (year) {
        year = "/" + year;
    }
    return `${date}${year}`;
};

export const arraySorter = (data) => {
    const sortedProducts = [...data].sort((a, b) => {
        const firstWordA = a.productName.split(" ")[0].toUpperCase();
        const firstWordB = b.productName.split(" ")[0].toUpperCase();

        if (firstWordA < firstWordB) {
            return -1;
        }
        if (firstWordA > firstWordB) {
            return 1;
        }
        return 0;
    });
    return sortedProducts;
};


export let expenseCategory = [
    "CAPITAL ACCOUNT",
    "CURRENT ASSETS",
    "CURRENT LIABILITIES",
    "DUTIES AND TAXES",
    "EXPENSE (DIRECT)",
    "EXPENSES (INDIRECT)",
    "FIXED ASSETS",
    "INCOME ( INDIRECT)",
    "INCOME (DIRECT )",
    "INVESTMENT",
    "LOAN & ADVANCES",
    "LOAN ( LIABILITIES)",
    "PRE OPERATIVE EXPENSES",
    "PROFIT & LOSS",
    // "PROVISION/ EXPENSES PAYABLE",
    "RESERVES & SURPLUS",
    "REVENUE ACCOUNT",
    "SECURED LOAN",
    "SECURITIES & DEPOSITS (ASSET)",
    "STOCK IN HAND",
    "SUSPENSE ACCOUNT",
    "UNSECURED LOAN"
]

export let ExpenseCategory2 = [
    "EXPENSE (DIRECT)",
    "EXPENSES (INDIRECT)",
]

export const arraySorterByParticularField = (data, fieldName) => {
    return [...data].sort((a, b) => {
        const firstWordA = a[fieldName].split(" ")[0].toUpperCase();
        const firstWordB = b[fieldName].split(" ")[0].toUpperCase();
        if (firstWordA < firstWordB) {
            return -1;
        }
        if (firstWordA > firstWordB) {
            return 1;
        }
        return 0;
    });
};


